import {Injectable, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable, Subject, takeUntil} from "rxjs";
import {DomSanitizer} from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class ImageService{

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

    const destroyListener$: Subject<void> = new Subject();

    this.getImageData("/assets/gfx/loader.gif")
      .pipe(takeUntil(destroyListener$.asObservable()))
      .subscribe({
        next: (value: any) => {
          (value as Blob).arrayBuffer().then(value1 => {
            this._defaultContent = this.convertData(value1);
          })
        },
        error: (error: any) => {
          console.error("Error fetching image URL:", error);
        },
        complete: () => {
        }
      }
    );
    this.getImageData("/assets/gfx/noimage.png")
      .pipe(takeUntil(destroyListener$.asObservable()))
      .subscribe({
        next: (value: any) => {
          (value as Blob).arrayBuffer().then(value1 => {
            this._noImageContent = this.convertData(value1);
          })
        },
        error: (error: any) => {
          console.error("Error fetching image URL:", error);
        },
        complete: () => {
        }
      }
    );
  }

  private _defaultContent: any;
  private _noImageContent: any;
  get defaultContent(): any {
    return this._defaultContent;
  }


  set defaultContent(value: any) {
    this._defaultContent = value;
  }


  get noImageContent(): any {
    return this._noImageContent;
  }


  getImageData(url: string): Observable<any> {
    return this.http.get(url, {
      responseType: "blob"
    });
  }

  convertData(value1: ArrayBuffer) {
    let binary = '';
    const bytes = new Uint8Array(value1);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return 'data:image/gif;base64,' + btoa(binary);
  }

}
